// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueCookie from 'vue-cookie'
import store from './store/'
import { userInfo } from './api'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import {
  DatePicker, Button, Pagination, Checkbox, Icon, Input, Loading, Message, Notification, Steps, Step, Table, TableColumn, Dialog, Select, Option, Tabs, MessageBox, Collapse,
  CollapseItem, Backtop, TabPane, Popover, Badge, Image, Form,
  FormItem, Divider, Radio, RadioGroup, RadioButton,
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import { getStore } from './utils/storage'
import "./assets/style/index.scss";
import "./assets/icon/fonts.css";
import "./assets/style/reset.scss";
import VDistpicker from 'v-distpicker'
import "babel-polyfill";
// 中英文切换
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import versionTood from '@/utils/versionUpdate';
import infiniteScroll from 'vue-infinite-scroll'
import lazyload from 'vue-lazyload'
import VueDOMPurifyHTML from 'vue-dompurify-html'
const zh = require('./components/language/zh');
const en = require('./components/language/en');

Object.assign(zh, zhLocale);
Object.assign(en, enLocale);

Vue.use(VueDOMPurifyHTML)
Vue.use(DatePicker)
Vue.use(Button)
Vue.use(Pagination)
Vue.use(Image)
Vue.use(Checkbox)
Vue.use(Icon)
Vue.use(Input)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tabs)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Backtop)
Vue.use(TabPane)
Vue.use(Popover)
Vue.use(Badge)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Divider)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(infiniteScroll)
Vue.use(lazyload, {
  preLoad:1.3,
  loading: '../static/images/none.svg',
  error: '../static/images/none.svg'
})
MessageBox.install = function (Vue, options) {
  Vue.prototype.$confirm = MessageBox.confirm;
}
Vue.use(MessageBox)
Vue.use(Loading.directive)
Vue.use(VueI18n)

const i18n = new VueI18n({
  //从localStorage里获取用户中英文选择，没有则默认中文
  locale: localStorage.getItem('languageSet') || 'zh',
  messages: {
    'zh': zh,
    'en': en
  }
})
ElementLocale.i18n((key, value) => i18n.t(key, value))

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
Vue.use(VueCookie)
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.config.productionTip = false
Vue.component('v-distpicker', VDistpicker)
if (getStore('state')) {
    store.commit('RECORD_STATE', { info: getStore('state') })
}
router.beforeEach(function (to, from, next) {
  versionTood.isNewVersion();
  if (to.name) {
    document.title = to.name;
    if (to.name == 'showAll') {
      document.title = '加入购物车成功';
    }
  }
  // if (getStore('state')) {
  //   store.commit('RECORD_STATE', { info: getStore('state') })
  // }
  next();
})

if (localStorage.getItem('login') == 'true') {
  store.commit('RECORD_USERINFO', JSON.parse(localStorage.getItem('userInfo')))
} else {
  store.commit('REMOVE_USERINFO');
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js